import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-bookmark",
  templateUrl: "./bookmark.component.html",
  styleUrls: ["./bookmark.component.scss"],
})
export class BookmarkComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
